import{atom as t}from"jotai/vanilla";function n(n){const o=t(n.getState());return o.onMount=t=>{const o=()=>{t(n.getState())},e=n.subscribe(o);return o(),e},t(t=>t(o),(t,o,e)=>n.dispatch(e))}export{n as atomWithStore};
//# sourceMappingURL=index.modern.mjs.map
